import httpClient from './httpClient'

const END_POINT = '/language-detect'

const detectLanguage = (query) => httpClient.get(END_POINT, { params: { query: query } })

export {
  detectLanguage
}
